<!--
  Datos de la cuenta: sólo lectura, y sólo el correo de acceso.

  Antes esto era un formulario con nombre y teléfono editables, pero la edición
  no funcionaba de punta a punta: `PUT /user/{id}` lee `fullname` y el front
  mandaba `name`, así que el nombre no se guardaba y encima el `full_name` del
  usuario quedaba en null en cada Guardar. Lo único que corresponde mostrar acá
  es la dirección a la que llega el enlace de acceso; el nombre y el teléfono del
  cliente son datos del contrato y viven en el ERP, no en el usuario del portal.
-->
<template>
  <b-card>
    <h5 class="mb-2">
      Datos de la cuenta
    </h5>

    <div class="account-field">
      <span class="account-field__label">Correo de acceso</span>
      <span class="account-field__value">{{ email }}</span>
    </div>

    <p class="account-field__hint mb-0">
      A esta dirección llega tu enlace de acceso al portal. Si necesitas
      cambiarla,
      <b-link :to="{ name: 'legal-contact' }">
        contáctanos
      </b-link>.
    </p>
  </b-card>
</template>

<script>
import { BCard, BLink } from "bootstrap-vue"

export default {
  components: {
    BCard,
    BLink,
  },
  data() {
    // El correo ya viene en el `userData` que guarda el login por magic link, así
    // que no hace falta pegarle a `/user/{id}` para mostrarlo.
    const userData = JSON.parse(localStorage.getItem("userData"))

    return {
      email: userData ? userData.email : "",
    }
  },
}
</script>

<style lang="scss" scoped>
.account-field {
    padding: 0.875rem 1rem;
    border: 1px solid var(--tm-border);
    border-radius: var(--tm-radius-sm);
    background-color: var(--tm-surface-muted);
}

.account-field__label {
    display: block;
    font-size: 0.6875rem;
    font-weight: 600;
    color: var(--tm-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 0.125rem;
}

.account-field__value {
    display: block;
    font-size: 0.9375rem;
    font-weight: 600;
    color: var(--tm-text);
    word-break: break-word;
}

.account-field__hint {
    margin-top: 0.75rem;
    font-size: 0.8125rem;
    color: var(--tm-text-muted);
}
</style>
